import { useMemo } from "react"

import {
  useAvailableMezoTokens,
  useAvailableTokens,
  useDepositedTokens,
} from "#/shared/hooks"

import TokensIcons from "./TokensIcons"

type TokensToDisplay = "deposit-tokens" | "available-tokens" | "mezo-tokens"

type AvailableTokensProps = {
  tokensToDisplay: TokensToDisplay
}

export default function AvailableTokens({
  tokensToDisplay,
}: AvailableTokensProps) {
  const { availableTokens } = useAvailableTokens()
  const { depositTokens } = useDepositedTokens()
  const { availableTokens: availableMezoTokens } = useAvailableMezoTokens()

  const tokenList = useMemo(
    () => ({
      "available-tokens": availableTokens,
      "deposit-tokens": depositTokens,
      "mezo-tokens": availableMezoTokens,
    }),
    [availableTokens, depositTokens, availableMezoTokens],
  )

  return <TokensIcons tokens={tokenList[tokensToDisplay]} />
}
